import React, { useEffect, useState } from "react";
import "./App.css";
import TabbedInterface from "./components/cards";
import DistrictHeader from "./components/district_header";
import NavigationHeader from "./components/navigation_header";
import AllStaffHeader from "./components/header_all_staff";
import {
  Button,
  CircularProgress,
  Box,
  Grid,
  Drawer,
  Divider,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  ListItemButton,
  AppBar,
  Alert,
  ButtonGroup,
  AlertTitle,
  Typography
} from "@mui/material";

import ListIcon from "@mui/icons-material/List";
import ListItemIcon from "@mui/material/ListItemIcon";

import CssBaseline from "@mui/material/CssBaseline";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";


import { getFunctions, httpsCallable } from "firebase/functions";
import AdminStats from "./components/admin_stats";
const { staff_emails } = require("./components/staff_emails");

function App(props) {
  // Your web app's Firebase configuration

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const config = {
    apiKey: "AIzaSyDlXuLrebp7QQaX2i7Sagtmi3z-ZLihEbg",
    authDomain: "epic-store-intrinsic.firebaseapp.com",
    projectId: "epic-store-intrinsic",
    storageBucket: "epic-store-intrinsic.appspot.com",
    messagingSenderId: "411861662359",
    appId: "1:411861662359:web:0d9322c8c1093e841007d2",
    measurementId: "G-S9MKBDGDWL",
  };

  // Initialize Firebase
  !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
  const provider = new firebase.auth.GoogleAuthProvider();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null); // Local signed-in state.
  const [admin, setAdmin] = useState(false);
  const [language, setLanguage] = useState("english");
  const [currentStudentEmail, setCurrentStudentEmail] = useState([]);
  const [advisoryData, setAdvisoryData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [parentEmails, setParentEmails] = useState([]);

  const drawerWidth =
    //240
    advisoryData.length > 0 && currentStudentEmail.length === 0 ? 200 : 0;

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const drawer = (
    <div>
      <Typography>Select an advisory group</Typography>
      <Box m={5}/>
      <Divider/>
      {advisoryData.length > 0
          ? [...new Set(advisoryData.map((x) => x.grade_level))].sort((a,b)=>a-b).map(xy=>
            <React.Fragment key={xy}>
              <Typography  >Grade Level {xy}</Typography>
            <List>
            {advisoryData.length > 0
              ? [...new Set(advisoryData.filter(x=>x.grade_level === xy).map((x) => x.advisors))]
                  .sort()
                  .map((advisor, index) => (
                    <React.Fragment key={advisor}>
                      <ListItem key={advisor} disablePadding>
                        <ListItemButton
                          onClick={() => {
                            //setCurrentStudentEmail([])
                            //console.log("set advisory to ", { advisor, index });
                            setCurrentStudentEmail(
                              advisoryData
                                .filter((x) => x.advisors === advisor)
                                .sort((a, b) => a.onegoal_points - b.onegoal_points)
                                .map((x) => x.email)
                            );
                            handleDrawerToggle(false);
                          }}
                        >
                          <ListItemIcon>{<ListIcon />}</ListItemIcon>
                          <ListItemText primary={advisor} />
                        </ListItemButton>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))
              : null}
          </List>
          </React.Fragment>
            )
      : null}
      <Divider />
    </div>
  );

  //sign in and sign out
  const signInWithGoogle = async () => {
    setLoading(true);
    try {
      //firebase.auth().signInWithRedirect(provider);
      firebase.auth().signInWithPopup(provider);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const signOut = async () => {
    setLoading(true);
    setAdmin(false);

    try {
      await firebase.auth().signOut();
      setUser(null);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const changeLanguage = async () => {
    setLanguage(language === "english" ? "spanish" : "english");
  };

  useEffect(() => {
    firebase.analytics().logEvent("visit");
    return firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        console.log("signed in: ", user.email);
        setUser(user);
        const functions = getFunctions();
        const getContacts = httpsCallable(functions, "getStudentContacts");

        getContacts().then((data) => {
          //console.log("parent emails", data.data[0]);
          setParentEmails(data.data[0]);

          if (staff_emails.includes(user.email)) {
            setAdmin(true);

            const getAdvisoryData = httpsCallable(functions, "getAdvisoryData");

            getAdvisoryData({})
              .then((result) => {
                //console.log("advisory", [...new Set(result.data[0])]);
                firebase
                  .analytics()
                  .logEvent("page_view", { page_title: "advisory view" });
                setAdvisoryData([...new Set(result.data[0])]);
                //console.log([...new Set(result.data[0])]);
              })
              .catch((err) => console.log(err));

            //setCurrentStudentEmail([emails[Math.floor(Math.random() * emails.length)]]);
            //setCurrentStudentEmail(emails[8]);
            //setCurrentStudentEmail(['gbances@intrinsicschools.org'])
            //setCurrentStudentEmail(['kgarcia4@intrinsicschools.org']);
          } else {
            // add logic to check if email is included in parent emails

            // otherwise set it as student user

            //downtown student
            //setCurrentStudentEmail(['jallengates@intrinsicschools.org'])
            //belmont student
            //setCurrentStudentEmail(["yayala@intrinsicschools.org"]);
            //ms student
            //setCurrentStudentEmail(['ycanutoramirez@intrinsicschools.org'])
            //setCurrentStudentEmail(['csalgado3@intrinsicschools.org'])
            setCurrentStudentEmail([user.email]);
            //setCurrentStudentEmail(["krosario2@intrinsicschools.org"])
            firebase
              .analytics()
              .logEvent("page_view", { page_title: "home page" });
          }
        });
      } else {
        setUser(false);
      }
    });
  }, []);

  return (
    <div
      className="App-header "
      style={{
        //backgroundImage: `url(${
        //  process.env.PUBLIC_URL + "/Spirit-Mountain.jpg"
        //})`,
        backgroundColor: "white",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        //width: '100vw',
      }}
    >
      <Grid container>
        <Grid item xs={1} sm={1} md={3}></Grid>
        <Grid item xs={10} sm={10} md={6}>
          <DistrictHeader
            language={language}
            changeLanguage={changeLanguage}
            user={user}
          />
        </Grid>
        <Grid item xs={1} sm={1} md={3}></Grid>
        <Grid item xs={1} sm={1} md={3}></Grid>
        <Grid item xs={10} sm={10} md={6}>
          <NavigationHeader
            user={user}
            signInWithGoogle={signInWithGoogle}
            language={language}
            signOut={signOut}
            admin={admin}
            advisoryData={advisoryData}
            currentStudentEmail={currentStudentEmail}
            handleDrawerToggle={handleDrawerToggle}
            resetCurrentStudentEmail={() => setCurrentStudentEmail([])}
          />
        </Grid>
        <Grid item xs={1} sm={1} md={3}></Grid>
        {admin ? (
          <Grid container>
            <Grid item xs={1} sm={1} md={3}></Grid>
            <Grid item xs={10} sm={10} md={6}>
              <AllStaffHeader
                user={user}
                signInWithGoogle={signInWithGoogle}
                language={language}
                signOut={signOut}
                admin={admin}
                advisoryData={advisoryData}
                currentStudentEmail={currentStudentEmail}
                handleDrawerToggle={handleDrawerToggle}
                resetCurrentStudentEmail={() => setCurrentStudentEmail([])}
              />
            </Grid>
            <Grid item xs={1} sm={1} md={3}></Grid>
          </Grid>
        ) : null}
        {/*         <Grid item xs={1} sm={1} md={3}></Grid>
        {admin && advisoryData.length > 0 ? (
          <Grid item xs={10} sm={10} md={6}>
            <header className="App-header" id="advisor-stats">
              <AdminStats
                advisoryData={advisoryData}
                admin={admin}
                currentStudentEmail={currentStudentEmail}
              />
            </header>
            <Box m={15} />
          </Grid>
        ) : (
          <Grid item xs={10} sm={10} md={6}></Grid>
        )}
        <Grid item xs={1} sm={1} md={3}></Grid> */}
        <Grid item xs={1} sm={1} md={3}></Grid>
        <Grid item xs={10} sm={10} md={6}>
          {loading ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : !user ? null : (
            <React.Fragment>
              <CssBaseline />

              <Drawer
                sx={{
                  width: drawerWidth,
                  flexShrink: 0,
                  "& .MuiDrawer-paper": {
                    width: drawerWidth,
                    boxSizing: "border-box",
                  },
                }}
                open={drawerOpen}
                //variant="permanent"
                anchor="left"
                onClose={() => handleDrawerToggle(false)}
              >
                {drawer}
              </Drawer>
              <Box m={2} />
              {currentStudentEmail.map((studentEmail) => (
                <React.Fragment key={studentEmail}>
                  <TabbedInterface
                    parentEmails={parentEmails.filter(
                      (x) => x.student_email === studentEmail
                    )}
                    user={user}
                    student_email={studentEmail}
                    admin={admin}
                    language={language}
                    advisoryData={admin ? advisoryData : null}
                  />{" "}
                  <Box m={5} />{" "}
                </React.Fragment>
              ))}
              <Box m={2} />
            </React.Fragment>
          )}
        </Grid>
        <Grid item xs={1} sm={1} md={3}></Grid>
      </Grid>
    </div>
  );
}

export default App;
